import React, { useState } from "react";
import VideoPopup from "../../common/Modals/VideoPopup";

const NewInstallationDetails = () => {
  const [isVideoOpen,setIsVideoOpen] = useState(false);
  return (
    <>
      <div className="tp-service-page pt-140 pb-140">
        <div className="container">
          <div className="row pb-30">
            <div className="col-lg-6 mb-30">
              <div className="tp-sv-inner-img w-img">
                <img src="/assets/img/service/service-new-installation1.jpeg" alt="" />
              </div>
            </div>
            <div className="col-lg-6 mb-30">
              <div className="tp-sv-inner-img w-img">
                <img src="/assets/img/service/service-new-installation2.jpeg" alt="" />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="tp-sv__content">
                <h3 className="tp-sv__title">Premium Lift Installation Services</h3>
                <p>
                Lumetiq Elevators Pvt Ltd provides top-tier lift installation 
                  services designed to enhance accessibility and efficiency in any building. 
                  Our skilled professionals ensure a seamless and secure installation process, 
                  tailored to the specific needs of our clients.{" "}
                </p>

                <p>
                We utilize state-of-the-art technology and high-quality materials to deliver 
                  safe and reliable elevators. Our team adheres to the highest industry standards, 
                  ensuring superior performance and durability.
                </p>

                <h4 className="tp-sv__subtitle">
                Our Step-by-Step Installation Approach
                </h4>
                <p>
                Our structured approach guarantees a hassle-free experience. We conduct 
                  thorough site assessments, create customized design plans, source premium 
                  materials, and execute precise structural integrations, culminating in 
                  rigorous testing and final commissioning.
                </p>
                <p>
                Whether it's a residential, commercial, or industrial lift installation, we 
                  focus on delivering solutions that prioritize safety, efficiency, and long-term 
                  value.
                </p>

                <p>
                Choose Lumetiq Elevators Pvt Ltd for innovative and dependable lift installation 
                  services that redefine vertical mobility.
                </p>

                <div className="tp-sv__video">
                  <div
                    className="tp_sv__video-bg"
                    // data-background="/assets/img/service/service-blog-bg.jpg"
                    style={{
                      backgroundImage: `url("/assets/img/service/service-blog-bg.jpg")`,
                    }}
                  >
                    {/* <div className="pt-180 pb-180 text-center p-relative">
                      <span>
                        <button
                          onClick={()=> setIsVideoOpen(true)}
                          className="sv-video sv-popup-video"
                        >
                          <i className="fas fa-play"></i>
                        </button>
                      </span>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* video modal start */}
      <VideoPopup
        isVideoOpen={isVideoOpen}
        setIsVideoOpen={setIsVideoOpen}
        videoId={"EW4ZYb3mCZk"}
      />
      {/* video modal end */}
    </>
  );
};

export default NewInstallationDetails;
